import React from 'react';
import { TableRow } from '@mui/material';
import TableCell from 'src/components/Table/TableCell';
import PropTypes from 'prop-types';
import { formatPositiveAmount, formatNegativeAmount } from 'src/utils/formatAmout';
import { roundNumberToDecimals } from 'src/utils/common';
import selectFormatDate from 'src/utils/selectDateFormat';
import dateFormatType from 'src/utils/dateFormatType';

const CapitalBalanceSummaryRow = ({
  rawDate,
  totalInitialBalance,
  totalEquipmentCost,
  totalInitialPayment,
  totalMonthlyPrincipal,
  totalContribution,
  totalResidual,
  totalFinalBalance
}) => {

  return (
    <TableRow hover>
      <TableCell align="center">{selectFormatDate(rawDate, dateFormatType.MONTH_AND_YEAR) || '-'}</TableCell>
      <TableCell align="center">
        {formatPositiveAmount(roundNumberToDecimals(totalInitialBalance ?? 0, 2))}
      </TableCell>
      <TableCell align="center">
        {formatPositiveAmount(roundNumberToDecimals(totalEquipmentCost ?? 0, 2))}
      </TableCell>
      <TableCell align="center">
        {totalInitialPayment
          ? formatNegativeAmount(roundNumberToDecimals(totalInitialPayment, 2))
          : '-'}
      </TableCell>
      <TableCell align="center">
        {totalMonthlyPrincipal
          ? formatNegativeAmount(roundNumberToDecimals(totalMonthlyPrincipal, 2))
          : '-'}
      </TableCell>
      <TableCell align="center">
        {formatNegativeAmount(roundNumberToDecimals(totalContribution ?? 0, 2))}
      </TableCell>
      <TableCell align="center">
        {formatNegativeAmount(roundNumberToDecimals(totalResidual ?? 0, 2))}
      </TableCell>
      <TableCell align="center" sx={{ fontWeight: 'bold' }}>
        {formatPositiveAmount(roundNumberToDecimals(totalFinalBalance ?? 0, 2))}
      </TableCell>
    </TableRow>
  );
};

CapitalBalanceSummaryRow.propTypes = {
  rawDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  totalInitialBalance: PropTypes.number,
  totalEquipmentCost: PropTypes.number,
  totalInitialPayment: PropTypes.number,
  totalMonthlyPrincipal: PropTypes.number,
  totalContribution: PropTypes.number,
  totalResidual: PropTypes.number,
  totalFinalBalance: PropTypes.number
};

export default CapitalBalanceSummaryRow;

